/**
 * EVC Multiply Dialog Content Container
 *
 * Wrapped with withSuspense for loading states.
 */

import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'
import { type Address } from 'viem'
import { EvcMultiplyDialogContent } from './EvcMultiplyDialogContent'

interface EvcMultiplyDialogContentContainerProps {
  closeDialog: () => void
  collateralVault: Address
  collateralSymbol: string
  collateralAmount: string
  collateralDecimals: number
  collateralAsset: Address
  collateralLogoURI?: string
  liabilityVault: Address
  liabilitySymbol: string
  borrowAmount: string
  liabilityDecimals: number
  liabilityAsset: Address
  liabilityLogoURI?: string
  subAccountId?: number
  wrapCollateralFromNative?: boolean
  multiplier: number
  slippage: number
  totalAssets?: bigint
  totalShares?: bigint
  isModifyingExistingPosition: boolean
}

function EvcMultiplyDialogContentContainerRaw(props: EvcMultiplyDialogContentContainerProps) {
  return <EvcMultiplyDialogContent {...props} />
}

const EvcMultiplyDialogContentContainerWithSuspense = withSuspense(
  EvcMultiplyDialogContentContainerRaw,
  DialogContentSkeleton,
)

export { EvcMultiplyDialogContentContainerWithSuspense as EvcMultiplyDialogContentContainer }
